import React, { useState, useEffect } from 'react';
import { LandingNav } from '../components/landing/LandingNav';
import { Hero } from '../components/landing/Hero';
import { LegalMarquee } from '../components/landing/LegalMarquee';
import { VideoSection } from '../components/landing/VideoSection';
import { PainSection } from '../components/landing/PainSection';
import { Normativa2026 } from '../components/landing/Normativa2026';
import { FeaturesBento } from '../components/landing/FeaturesBento';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Pricing } from '../components/landing/Pricing';
import { CompetitorComparison } from '../components/landing/CompetitorComparison';
import { FaqSection } from '../components/landing/FaqSection';
import { FooterLanding } from '../components/landing/FooterLanding';
import { DemoModal } from '../components/landing/DemoModal';
import { ChatWidget } from '../components/landing/ChatWidget';
import '../components/landing/landing.css';

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);
  const abrirDemo = () => setDemoOpen(true);

  useEffect(() => {
    document.title = 'Control Horario y Registro de Jornada para Empresas | GestionaEmpleados';
    if (new URLSearchParams(window.location.search).get('demo') === '1') setDemoOpen(true);
  }, []);

  return (
    <div className="bg-bone min-h-screen text-left" data-testid="landing-page">
      <LandingNav onDemo={abrirDemo} />
      <Hero onDemo={abrirDemo} />
      <LegalMarquee />
      <VideoSection />
      <PainSection />
      <Normativa2026 onDemo={abrirDemo} />
      <FeaturesBento />
      <HowItWorks />
      <Pricing onDemo={abrirDemo} />
      <CompetitorComparison onDemo={abrirDemo} />
      <FaqSection />
      <FooterLanding onDemo={abrirDemo} />
      <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
      <ChatWidget />
    </div>
  );
}
